<div class="order-state body-0" [ngClass]="{ description: description() }">
    @if (dateLabel() && date()) {
        <div class="date">
            <div>{{ dateLabel() }}</div>
            <div>{{ date() | dateTime }}</div>
        </div>
    }
    @if (isDisplayTrackingNumber()) {
        <div class="tracking">
            <div>Tracking number:</div>
            @if (trackingLink()) {
                <a class="link underline" (click)="redirect()">{{ trackingNumber() }}</a>
            } @else {
                <span class="link">{{ trackingNumber() }}</span>
            }
        </div>
    }
    @if (showProjectedContent()) {
        <div class="projected-content-wrapper">
            <ng-content></ng-content>
        </div>
    }

    @if (description()) {
        <div class="description">
            <span [innerHTML]="description()"></span>
            @if (learnMoreLink() && linkLabel()) {
                <a class="link" [href]="learnMoreLink()">
                    {{ linkLabel() }}
                </a>
            }
        </div>
    }
</div>
